// extracted by mini-css-extract-plugin
export default {"fixed":"MiniOrder_fixed__-Q2BT","qty":"MiniOrder_qty__c12xd","total":"MiniOrder_total__zMfaR"};